// @flow

import { call, put, takeEvery } from 'redux-saga/effects';

import { updateResource } from '@redux/components/ApiRequest/actions';
import { authApiUrl } from '@lib';

import type { Action } from '../types';

import { FORGOT_PASSWORD_SET_REQUEST } from './constants';
import { successForgotPasswordSet, errorForgotPasswordSet } from './actions';

export function* forgotPasswordSetRequestFlow(action: Action): Generator<Function, any, any> {
  const { formValues }: Action = action;

  yield put(
    updateResource(
      'any',
      `${authApiUrl}/v1/password-resets`,
      { user: formValues },
      successForgotPasswordSet,
      errorForgotPasswordSet
    )
  );
}

// yield put(yapitahealth/backend/api/v1/password-resets

// )

export function* forgotPasswordSetFlow(action: Action): Generator<Function, any, any> {
  switch (action.type) {
    case FORGOT_PASSWORD_SET_REQUEST:
      yield call(forgotPasswordSetRequestFlow, action);
      break;

    default:
      break;
  }
}

function* forgotPasswordSetWatcher(): Generator<Function, any, any> {
  yield takeEvery([FORGOT_PASSWORD_SET_REQUEST], forgotPasswordSetFlow);
}

export default forgotPasswordSetWatcher;
